export class BaseEditComponent {
  public loading: boolean;
  public loaded: boolean;
  public pageLoading: boolean;
  public editMode: boolean;

  get isInitialLoading() {
    return this.pageLoading || (this.loading && !this.loaded);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/common/base-component.ts